import { getDecimalSeparator, getGroupSeparator } from "locales"

export const parseFloatByLocale = (value) => {
  try {
    const decimalSeparator = getDecimalSeparator();
    return parseFloat(value.toString().replace(decimalSeparator, '.'));
  } catch (e) {
    return null;
  }
}

export const parseNumberByLocaleWithGroup = (value) => {
  try {
    const decimalSeparator = getDecimalSeparator();
    const groupSeparator = getGroupSeparator();

    let normalized = value.toString().split(groupSeparator).join('');
    normalized = normalized.replace(decimalSeparator, '.');

    return Number(normalized);
  } catch (e) {
    return null;
  }
}